import React, { FC } from "react";
import { SVGProps } from "react";

interface DisconnectProps extends SVGProps<SVGSVGElement> {
  size: number;
}

export const DisconnectIcon: FC<DisconnectProps> = (props) => {
  const { size = 24, ...rest } = props;

  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_3937_6642)">
        <path
          clipRule="evenodd"
          d="M4.0451 2.98432L4.92899 3.8682L6.16642 2.63076C7.24036 1.55682 8.98157 1.55682 10.0555 2.63076L12.7072 5.28241L13.591 4.39853L14.6517 5.45919L12.7072 7.40373L14.6517 9.34828L13.591 10.4089L11.6465 8.46439L8.46452 11.6464L10.4091 13.5909L9.3484 14.6516L7.40386 12.707L5.45932 14.6516L4.39866 13.5909L5.28254 12.707L2.63089 10.0554C1.55695 8.98144 1.55695 7.24024 2.63089 6.1663L3.86833 4.92886L2.98444 4.04498L4.0451 2.98432ZM11.6465 6.34307L8.99485 3.69142C8.5067 3.20327 7.71524 3.20327 7.22708 3.69142L3.69155 7.22696C3.20339 7.71511 3.20339 8.50657 3.69155 8.99472L6.3432 11.6464L11.6465 6.34307ZM19.955 21.0155L19.0711 20.1317L17.8337 21.3691C16.7597 22.443 15.0185 22.443 13.9446 21.3691L11.2929 18.7174L10.4091 19.6013L9.3484 18.5407L18.5408 9.34828L19.6015 10.4089L18.7176 11.2928L21.3692 13.9445C22.4432 15.0184 22.4432 16.7596 21.3692 17.8336L20.1318 19.071L21.0157 19.9549L19.955 21.0155ZM12.3536 17.6568L15.0053 20.3084C15.4934 20.7966 16.2849 20.7966 16.773 20.3084L20.3086 16.7729C20.7967 16.2847 20.7967 15.4933 20.3086 15.0051L17.6569 12.3535L12.3536 17.6568Z"
          // fill="white"
          // fillOpacity="0.36"
        />
      </g>
      <defs>
        <clipPath id="clip0_3937_6642">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
